export default __webpack_public_path__ + "static/media/muscleAches.2c670ccf.svg";